module.exports = __webpack_public_path__ + "static/media/consumer.8f078e6d.svg";